<template>
  <div>
    <br />
    <div class="row align-items-end">
      <div class="col-3 my-3">
        <label for="">Client</label>
        <vue-select :options="customers" v-model="payment.customer_reference"
          @input="getCustomerSalesUnpaid(payment.customer_reference)" labelColumn="society" valueColumn="reference" />
      </div>

      <div class="col-6 my-3">
        <label for=""> Factures impayées </label>
        <select class="form-select" v-model="payment.sale_reference">
          <option value="" default></option>
          <option v-for="(sale, index) in sales" :key="index" :value="sale.reference"
            :class="sale.totalPriceTTC !== sale.amountUnpaid ? 'text-danger fw-bold' : ''">
            Nº {{ sale.passPermit }} / {{ sale.date }} /
            {{ sale.totalPriceTTC }} DH / Reste : {{ sale.amountUnpaid }} DH
          </option>
        </select>

      </div>

      <div class="col my-3">
        <label for=" "> </label>
        <button @click="setUnpaidAmount(payment.sale_reference)" class="btn btn-secondary">
          Remplir
        </button>
      </div>
      <div class="col-2 my-3">
        <label for="">Montant</label>
        <input type="text" v-model="payment.amount" class="form-control" />
      </div>

      <div class="col-3 my-3">
        <label for="">Date</label>
        <input type="date" v-model="payment.date" class="form-control" />
      </div>

      <div class="col-3 my-3">
        <label for="">Mode de paiement</label>
        <select v-model="payment.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div> 

      <div v-if="payment.paymentMethod == 'Chèque' || payment.paymentMethod == 'Effet'" class="col-3 my-3">
        <label for="">Numéro de chèque</label>
        <input type="text" v-model="payment.checkNumber" class="form-control" />
      </div>

      <div v-if="payment.paymentMethod == 'Virement bancaire'" class="col-3 my-3">
        <label for="">Numéro de virement bancaire</label>
        <input type="text" v-model="payment.bankTransferNumber" class="form-control" />
      </div>


      <div class="col-12 my-3">
        <label for="">Remarques</label>
        <textarea v-model="payment.remark" class="form-control" cols="30" rows="3"></textarea>
      </div>
    </div>
    <br />
    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(payment)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import customers from "../../router/routes/customers";

export default {
  data() {
    return {
      payment: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentMethod: "Espèce",
        amount: 0,
        remark: "",
  
      },
    };
  },
  computed: {
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("sale", { sales: "getSales" }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("payment/store", data);
    },
    async getCustomerSalesUnpaid(customer_reference) {
      let customer = this.customers.find(p => p.reference == customer_reference)
      this.payment.amount = 0;
      if(customer)
        this.$store.dispatch("sale/getCustomerSalesUnpaid", customer_reference);
    },
    
    setUnpaidAmount(reference) {
      const selectedSale = this.sales.find(sale => sale.reference === reference);
      if (selectedSale) {
        this.payment.amount = selectedSale.amountUnpaid;
      }
    }
  },
  beforeMount() {
    this.$store.dispatch("customer/getAll");
  },
};
</script>
